/**
 * Auth-token helpers + authenticated axios factory.
 * Extracted from App.js in SPD v5.53 Phase D.
 *
 * BACKEND_URL / API are constants derived from REACT_APP_BACKEND_URL.
 * The authAxios() factory returns an axios instance that:
 *   - injects the Bearer token from localStorage on every request
 *   - clears the token + redirects to / on any 401 from an /auth/ endpoint
 */
import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem('startech_token');
export const setToken = (token) => localStorage.setItem('startech_token', token);
export const clearToken = () => localStorage.removeItem('startech_token');

export const authAxios = () => {
  const instance = axios.create();
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      // Only clear token and redirect on 401 from auth endpoints
      // Don't logout on network errors or other failures
      if (err.response?.status === 401 && err.config?.url?.includes('/auth/')) {
        clearToken();
        window.location.href = '/';
      }
      return Promise.reject(err);
    }
  );
  return instance;
};
